var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9A9 9 0 1 0 0 9a9 9 0 0 0 18 0Zm-3.773-3.422a.6.6 0 0 0-.849-.005L7.737 11.15 5.229 8.584l-.056-.05a.6.6 0 0 0-.802.889l2.93 2.996.056.051a.6.6 0 0 0 .795-.043l6.07-6 .05-.057a.6.6 0 0 0-.045-.792Z",
    fill: "currentcolor"
  })));
};

export default SvgSuccess;